import type { BorderColorModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { useSemanticModifierValue } from "@agent-ui/features/modifiers/hooks/useSemanticModifierValue";
import { parseColorValue } from "@agent-ui/features/modifiers/utils/parseComputedValue";
import ColorSelector from "@v2/features/modifiers/base/ColorSelector";
import { useOverridableState } from "replo-runtime/shared/hooks/useOverridableState";

interface BorderColorModifierProps {
  onChange: (modifier: BorderColorModifierValue) => void;
}

const BorderColorModifier: React.FC<BorderColorModifierProps> = ({
  onChange,
}) => {
  const extractedColor =
    useSemanticModifierValue({
      semanticExtractor: ({ computedStyles }) => {
        return (
          parseColorValue(
            computedStyles.borderBottomColor ??
              computedStyles.borderTopColor ??
              computedStyles.borderRightColor ??
              computedStyles.borderLeftColor,
          ) ?? undefined
        );
      },
    }) ?? null;

  const [currentColor, setCurrentColor] = useOverridableState(
    extractedColor,
    React.useCallback(
      (color: string | null) => {
        onChange({
          type: "borderColor",
          value: color,
        });
      },
      [onChange],
    ),
  );

  return <ColorSelector value={currentColor} onChange={setCurrentColor} />;
};

export default BorderColorModifier;
